<div [id]="'procedure-'+brand">
  <div class="stepper mb-3">
    <div class="grid">
      @for (item of steps; track item) {
        <div
          [className]="currentStep >= item.step ? 'step current' : 'step'"
          (click)="setStep(item.step)"
          >
          <div>
            <picture></picture>
            <span>{{ item.step }}</span>
          </div>
        </div>
      }
    </div>
    <p class="current-step">{{ getCurrentStepLabel() }}</p>
  </div>
</div>

<div [hidden]="currentStep !== 1">
  <app-account-information (accountInformation)="setAccountInformation($event)"></app-account-information>
</div>
<div [hidden]="currentStep !== 2">
  <app-account-billing-address [accountInformation]="accountInformation" (accountAddress)="setAccountAddress($event)"></app-account-billing-address>
</div>
<div [hidden]="currentStep !== 3">
  <app-account-documents (accountDocuments)="setAccountDocuments($event)"></app-account-documents>
</div>
<div [hidden]="currentStep !== 4">
  <app-account-bank-information (accountBankInformation)="setAccountBankInformation($event)"></app-account-bank-information>
</div>
<div [hidden]="currentStep !== 5">
  <app-account-confirmation [accountInformation]="accountInformation" (accountConfirmation)="setAccountConfirmation($event)"></app-account-confirmation>
</div>
